// import './public-path'
import '@/services/logger'
import { createRoot } from 'react-dom/client'
import '@/assets/styles/global.scss'

import App from './App'
const root = document.querySelector('#root')

export default App
if (root) {
  createRoot(root).render(<App />)
}

// function render(props: any) {
//   const { container } = props
//   root = createRoot(container ? container.querySelector('#root') : document.querySelector('#root'))
//   root.render(<App container={container} />)
// }

// if (!window.__POWERED_BY_QIANKUN__) {
//   render({})
// }

// export async function bootstrap() {
//   logger.debug('react app bootstraped')
// }

// export async function mount(props: any) {
//   logger.debug('react app mount')
//   window.$mainApp = props
//   render(props)
// }

// export async function unmount() {
//   root?.unmount?.()
// }
